/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as SigninIndexRouteImport } from './routes/signin.index'
import { Route as SigninCallbackRouteImport } from './routes/signin.callback'
import { Route as TryBriefRouteImport } from './routes/try.brief'
import { Route as AppBriefsIndexRouteImport } from './routes/app.briefs.index'
import { Route as AppBriefsBriefIdRouteImport } from './routes/app.briefs.$briefId'
import { Route as AppVendorsIndexRouteImport } from './routes/app.vendors.index'
import { Route as AppVendorsVendorIdRouteImport } from './routes/app.vendors.$vendorId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const SigninIndexRoute = SigninIndexRouteImport.update({
  id: '/signin/',
  path: '/signin/',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninCallbackRoute = SigninCallbackRouteImport.update({
  id: '/signin/callback',
  path: '/signin/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const TryBriefRoute = TryBriefRouteImport.update({
  id: '/try/brief',
  path: '/try/brief',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBriefsIndexRoute = AppBriefsIndexRouteImport.update({
  id: '/briefs/',
  path: '/briefs/',
  getParentRoute: () => AppRoute,
} as any)
const AppBriefsBriefIdRoute = AppBriefsBriefIdRouteImport.update({
  id: '/briefs/$briefId',
  path: '/briefs/$briefId',
  getParentRoute: () => AppRoute,
} as any)
const AppVendorsIndexRoute = AppVendorsIndexRouteImport.update({
  id: '/vendors/',
  path: '/vendors/',
  getParentRoute: () => AppRoute,
} as any)
const AppVendorsVendorIdRoute = AppVendorsVendorIdRouteImport.update({
  id: '/vendors/$vendorId',
  path: '/vendors/$vendorId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/signin/callback': typeof SigninCallbackRoute
  '/try/brief': typeof TryBriefRoute
  '/app/': typeof AppIndexRoute
  '/signin/': typeof SigninIndexRoute
  '/app/briefs/$briefId': typeof AppBriefsBriefIdRoute
  '/app/vendors/$vendorId': typeof AppVendorsVendorIdRoute
  '/app/briefs/': typeof AppBriefsIndexRoute
  '/app/vendors/': typeof AppVendorsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signin/callback': typeof SigninCallbackRoute
  '/try/brief': typeof TryBriefRoute
  '/app': typeof AppIndexRoute
  '/signin': typeof SigninIndexRoute
  '/app/briefs/$briefId': typeof AppBriefsBriefIdRoute
  '/app/vendors/$vendorId': typeof AppVendorsVendorIdRoute
  '/app/briefs': typeof AppBriefsIndexRoute
  '/app/vendors': typeof AppVendorsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/signin/callback': typeof SigninCallbackRoute
  '/try/brief': typeof TryBriefRoute
  '/app/': typeof AppIndexRoute
  '/signin/': typeof SigninIndexRoute
  '/app/briefs/$briefId': typeof AppBriefsBriefIdRoute
  '/app/vendors/$vendorId': typeof AppVendorsVendorIdRoute
  '/app/briefs/': typeof AppBriefsIndexRoute
  '/app/vendors/': typeof AppVendorsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/signin/callback'
    | '/try/brief'
    | '/app/'
    | '/signin/'
    | '/app/briefs/$briefId'
    | '/app/vendors/$vendorId'
    | '/app/briefs/'
    | '/app/vendors/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signin/callback'
    | '/try/brief'
    | '/app'
    | '/signin'
    | '/app/briefs/$briefId'
    | '/app/vendors/$vendorId'
    | '/app/briefs'
    | '/app/vendors'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/signin/callback'
    | '/try/brief'
    | '/app/'
    | '/signin/'
    | '/app/briefs/$briefId'
    | '/app/vendors/$vendorId'
    | '/app/briefs/'
    | '/app/vendors/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  SigninCallbackRoute: typeof SigninCallbackRoute
  TryBriefRoute: typeof TryBriefRoute
  SigninIndexRoute: typeof SigninIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/signin/': {
      id: '/signin/'
      path: '/signin'
      fullPath: '/signin/'
      preLoaderRoute: typeof SigninIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin/callback': {
      id: '/signin/callback'
      path: '/signin/callback'
      fullPath: '/signin/callback'
      preLoaderRoute: typeof SigninCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/try/brief': {
      id: '/try/brief'
      path: '/try/brief'
      fullPath: '/try/brief'
      preLoaderRoute: typeof TryBriefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/briefs/': {
      id: '/app/briefs/'
      path: '/briefs'
      fullPath: '/app/briefs/'
      preLoaderRoute: typeof AppBriefsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/briefs/$briefId': {
      id: '/app/briefs/$briefId'
      path: '/briefs/$briefId'
      fullPath: '/app/briefs/$briefId'
      preLoaderRoute: typeof AppBriefsBriefIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/vendors/': {
      id: '/app/vendors/'
      path: '/vendors'
      fullPath: '/app/vendors/'
      preLoaderRoute: typeof AppVendorsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/vendors/$vendorId': {
      id: '/app/vendors/$vendorId'
      path: '/vendors/$vendorId'
      fullPath: '/app/vendors/$vendorId'
      preLoaderRoute: typeof AppVendorsVendorIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppBriefsBriefIdRoute: typeof AppBriefsBriefIdRoute
  AppVendorsVendorIdRoute: typeof AppVendorsVendorIdRoute
  AppBriefsIndexRoute: typeof AppBriefsIndexRoute
  AppVendorsIndexRoute: typeof AppVendorsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppBriefsBriefIdRoute: AppBriefsBriefIdRoute,
  AppVendorsVendorIdRoute: AppVendorsVendorIdRoute,
  AppBriefsIndexRoute: AppBriefsIndexRoute,
  AppVendorsIndexRoute: AppVendorsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  SigninCallbackRoute: SigninCallbackRoute,
  TryBriefRoute: TryBriefRoute,
  SigninIndexRoute: SigninIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
